<div class="form-tc">
  <h2 class="title-form">
    <span>Ingrese su documento para </span>activar los beneficios
  </h2>
  <form [formGroup]="tcForm" autocomplete="off">
    <div [ngClass]="{ 'form-desk': !isMobile }" class="form-inputs">
      <div class="form_item grid-12">
        <mat-form-field appearance="outline">
          <mat-label>Tipo de documento</mat-label>
          <mat-select
            formControlName="documentType"
            (selectionChange)="selectedTypeDocument($event.value)"
          >
            <mat-option value=""> -- Selecciona una opción -- </mat-option>
            <mat-option
              *ngFor="let types of typeDocument"
              [value]="types.name"
              >{{ types.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <p class="error" *ngIf="tcForm.get('documentType').errors && submited">
          {{ messageErrorRequired }}
        </p>
      </div>

      <div class="form_item grid-12">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Número de documento</mat-label>
          <input
            type="{{ type }}"
            [min]="min"
            [max]="max"
            placeholder="0000000000"
            formControlName="documentNumber"
            matInput
            (keypress)="valdiateSimbol($event)"
            (keyup)="valdiateSimbolChange()"
          />
        </mat-form-field>
        <p
          class="error"
          *ngIf="tcForm.get('documentNumber').errors && submited"
        >
          {{ messageError }}
        </p>
      </div>
    </div>

    <div class="form_item grid-12">
      <mat-checkbox class="margin" formControlName="policyTerms">
        <p>
          Acepto los
          <a href="{{ hrefTermAndConditions }}" target="_blank" rel="noopener"
            >Términos y condiciones</a
          >, he leído y autorizo el
          <a href="{{ proceddingPersonalData }}" target="_blank"  rel="noopener"
            >Tratamiento de mis datos personales.</a
          >
        </p>
      </mat-checkbox>
      <p
        class="error checkbox-error"
        *ngIf="tcForm.get('policyTerms').errors && submited"
      >
        {{ messageErrorRequired }}
      </p>
    </div>

    <div class="content-btn">
      <button
        class="button_green"
        [ngClass]="{ disable: validForm === false }"
        (click)="setEventClick()">
        Enviar
      </button>
    </div>
  </form>
</div>
